<template>
  <div>
    <div style="margin: 20px">لطفا مخاطب نظرسنجی خود را انتخاب کنید.</div>
    <div v-if="isMobile">
      <v-card v-for="item in items" :key="item.FSerial" @click="nextStep(item)"
      :disabled="!item.active">
        <v-card-title class="info-detail">
          <div class="text-center">{{ item.Fname }} {{ item.Lname }}</div>
        </v-card-title>
        <div class="contain">
          <app-row
            icon="user"
            :title="isEmployee ? 'سمت: ' : 'درس : '"
            :value="isEmployee ? item.Chart_Name : item.Course_Name"
          />
          <app-row icon="building" title="مدرسه : " :value="item.School_Name" />
          <app-row
            icon="hashtag"
            title="كد مسئول : "
            :value="item.Num_System"
          />
        </div>
      </v-card>
    </div>
    <div v-else>
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="items"
        item-key="FSerial"
        :no-data-text="tableText"
        class="elevation-1 rounded2"
        :disable-pagination="true"
        :hide-default-footer="true"
      >
        <template v-slot:[`item.active`]="{ item }">
          <v-btn
            class="grid"
            v-if="item.active"
            color="primary white--text"
            rounded
            @click="$emit('nextStep', item)"
          >
            انتخاب
          </v-btn>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";
export default {
  components: {
    appRow: DetailRow,
  },
  data() {
    return {
      selected: [],

      headers: [
        {
          text: "نام",
          value: "Fname",
          width: "10%",
        },
        {
          text: "نام خانوادگي",
          value: "Lname",
          width: "15%",
        },
        {
          text: "كد مسئول",
          value: "Num_System",
          width: "10%",
        },
        {
          text: this.isEmployee ? "سمت" : "درس",
          value: this.isEmployee ? "Chart_Name" : "Course_Name",
          width: "32%",
        },
        {
          text: "مدرسه",
          value: "School_Name",
          width: "25%",
        },
        {
          text: "",
          value: "active",
          width: "8%",
        },
      ],
    };
  },
  props: ["items", "pollType"],
  computed: {
    tableText() {
      return this.$store.getters.tableText;
    },

    isMobile() {
      return this.$store.getters.isMobile;
    },
    isEmployee() {
      return this.pollType != 3;
    },
    isTeacher() {
      return this.pollType == 3;
    },
  },
  methods: {
    nextStep(item) {
      if (!item.active) {
        this.$store.commit(
          "SET_SNACKBAR_TEXT",
          "برای این فرد پیشتر نظرسنجی انجام شده است."
        );
      } else {
        this.$emit("nextStep", item);
      }
    },
  },
};
</script>
<style scoped>
.v-card {
  cursor: pointer;
}
</style>
